module.exports = __webpack_public_path__ + "static/media/back-to-top.88eec156.svg";